import i18n from "@/plugins/vue-i18n";
import user from "@/configs/user.config.json";

const Notifications = () =>
  import(/* webpackChunkName: "profile" */ "@/views/agent/profile/notifications");

const notifications = [
  {
    path: "notifications",
    name: "Notifications",
    component: Notifications,
    meta: {
      title: i18n.t("title.profile.notifications"),
      authorize: [user.agent],
    },
  },
];

export default notifications;
